import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Alerta from '../componentes/Alerta';
import Footer from '../componentes/Footer';
import HeroSection from '../componentes/HeroSection';
import BenefitsSection from '../componentes/BenefitsSection';
import ProjectsSection from '../componentes/ProjectsSection';
import CustomModal from '../componentes/Modal';
import { consultarPorCedula, consultarHistorial } from '../servicios/consultas';
import ModalVerificacion from '../componentes/ModalVerificacion';
import LoginForm from '../componentes/LoginForm';
import { login } from '../servicios/autenticacion';
import BarraNavegacion from '../componentes/BarraNavegacion';
import logo from '../data/inicio/logo.png';
import './Inicio.css';

const Inicio = () => {
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [verificationData, setVerificationData] = useState(null);
  const [showVerificationModal, setShowVerificationModal] = useState(false);

  const formatFirebaseError = (message) => {
    const errors = {
      'auth/invalid-email': 'Formato de email inválido',
      'auth/wrong-password': 'Contraseña incorrecta',
      'auth/user-not-found': 'Usuario no registrado',
      'auth/too-many-requests': 'Demasiados intentos. Intente más tarde',
      'auth/user-disabled': 'Cuenta deshabilitada'
    };
    return errors[message] || message;
  };

  const handleLogin = async (credentials) => {
    try {
      setIsVerifying(true);
      const userData = await login(
        credentials.email, 
        credentials.password, 
        credentials.role
      );

      setShowLoginModal(false);
      navigate(userData.rol === 'superadmin' ? '/admin-panel' : '/estudiante-home');
      
    } catch (error) {
      Alerta({
        type: 'error',
        title: 'Acceso denegado',
        content: formatFirebaseError(error.message),
        logoUrl: logo,
        onConfirm: () => setShowLoginModal(true)
      });
    } finally {
      setIsVerifying(false);
    }
  };

  const handleCertificateVerification = async () => {
    if (isVerifying) return;
    setIsVerifying(true);

    try {
      await Alerta({
        type: 'info',
        title: 'Verificación de Certificados',
        content: '<p class="custom-swal-instruction">Ingrese el número de cédula del estudiante</p>',
        logoUrl: logo,
        options: {
          input: 'text',
          inputLabel: 'Número de Cédula',
          inputPlaceholder: 'Ejemplo: 12345678',
          showCancelButton: true,
          confirmButtonText: 'Verificar',
          cancelButtonText: 'Cancelar',
          inputValidator: (value) => {
            if (!value) return 'Debe ingresar un número de cédula';
            if (!/^\d+$/.test(value)) return 'Solo se permiten números';
            return null;
          }
        },
        onConfirm: async (result) => {
          const cedula = result.value;
          
          try {
            const data = await consultarPorCedula(cedula);
            
            if (!data) {
              await Alerta({
                type: 'warning',
                title: 'Cédula no registrada',
                content: `No encontramos certificados para ${cedula}`,
                logoUrl: logo
              });
              return;
            }

            const historial = await consultarHistorial(cedula);
            setVerificationData({
              basic: data,
              history: historial
            });
            setShowVerificationModal(true);
            
          } catch (error) {
            throw new Error('Error al consultar los datos');
          }
        }
      });
    } catch (error) {
      Alerta({
        type: 'error',
        title: 'Error de verificación',
        content: error.message,
        logoUrl: logo
      });
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className="inicio-container">
      <BarraNavegacion onShowLogin={() => setShowLoginModal(true)} />

      <CustomModal 
        show={showLoginModal} 
        handleClose={() => setShowLoginModal(false)}
        title="Acceso Estudiantes"
      >
        <LoginForm 
          onLogin={handleLogin} 
          onClose={() => setShowLoginModal(false)}
          isSubmitting={isVerifying}
        />
      </CustomModal>

      <ModalVerificacion
        show={showVerificationModal}
        handleClose={() => {
          setShowVerificationModal(false);
          setVerificationData(null);
        }}
        data={verificationData}
      />

      <HeroSection />
      <BenefitsSection 
        onVerifyCertificate={handleCertificateVerification}
        isVerifying={isVerifying}
      />
      <ProjectsSection />
      <Footer />
    </div>
  );
};

export default Inicio;